<template>
    <div class="container">
      <el-row class="common-box">
        <div class="common-search">
          <el-form
            ref="formData"
            :model="formData"
            :inline="true"
            label-width="90px"
            class="formInline"
            size="mini"
            :rules="rules"
          >
            <el-form-item label="身份证号" prop="idCard">
              <el-input
                v-model="searchData.idCard"
                placeholder="请输入身份证号..."
                :maxlength="18"
              ></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="custEmpName">
              <el-input
                v-model="searchData.custEmpName"
                placeholder="请输入姓名..."
                :maxlength="6"
              ></el-input>
            </el-form-item>
            <el-form-item label="人员ID" prop="empPk">
              <el-input
                v-model="searchData.empPk"
                placeholder="请输入人员ID..."
                :maxlength="12"
              ></el-input>
            </el-form-item>
            <el-form-item label="NC编码" prop="custEmpCode">
              <el-input
                v-model="searchData.custEmpCode"
                placeholder="请输入NC编码..."
                :maxlength="12"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
            <el-select v-model="searchData.status" placeholder="请选择" clearable>
              <el-option label="全部" :value="null"></el-option>
              <el-option label="生效中" :value="0"></el-option>
              <el-option label="关闭" :value="1"></el-option>
            </el-select>
          </el-form-item>

          <div style="text-align: center;">
            <el-form-item>    
              <el-button class="search-btn" @click="getData(1)">搜索</el-button>
              <el-button
                class="search-btn"
                @click="exportData"
                style="margin-left: 20px"
                >导出</el-button
              >
              <el-button
                class="search-btn"
                style="margin-left: 20px"
                @click="add"
                >新增</el-button
              >
              <el-button
                class="search-btn"
                style="margin-left: 20px"
                @click="insertBatchs"
                >批量新增</el-button
              >
            </el-form-item>  
          </div>
  
            <!-- <el-form-item>
              <el-button class="search-btn" @click="downloadTmp()">下载模板</el-button>
              
            </el-form-item> -->
            <!-- size="mini" :disabled="auths.indexOf(2) < 0" round @click="uploadDialog=true" 
            size="mini" :disabled="auths.indexOf(2) < 0"  round @click="downloadTmp"
            -->
          </el-form>
        </div>
        <div class="common-box-body">
          <el-table
            :data="tableData"
            size="small"
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            border
            style="width: 100%"
            header-row-class-name="table-header"
          >
            <el-table-column
              type="index"
              label="编号"
              width="50"
              align="center"
            ></el-table-column>
            <!-- <el-table-column prop="idCard" label="身份证" align="center" :formatter = "formatIdCard"></el-table-column>
            <el-table-column prop="salemansName" label="姓名" align="center" :formatter = "formatName"></el-table-column> -->
            <el-table-column
              prop="custEmpName"
              label="姓名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="custEmpIdcard"
              label="身份证号"
              align="center"
              :formatter="formatIdCard"
            ></el-table-column>
            <el-table-column
              prop="empPk"
              label="人员ID"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="custEmpCode"
              label="NC编码"
              align="center"
            >
            </el-table-column>
            <el-table-column width="100" label="状态" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0">生效中</div>
                <div v-if="scope.row.status == 1">关闭</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="custRole"
              label="职位"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="updateTime"
              label="更新时间"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="createUser"
              label="创建人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="updateUser"
              label="更新人"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" width="150" align="center">
              <template slot-scope="scope" >
                <el-button v-if="scope.row.status == 0" type="text" size="mini" style="color: #1652ff;" @click="updateEmployee(scope.row)">修改</el-button>
                <el-button v-if="scope.row.status == 0" type="text" size="mini" style="color: rgb(245, 108, 108);" :loading="closeLoading" @click="closeEmployee(scope.row)">关闭</el-button>
                <span v-if="scope.row.status != 0">--</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination table-pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchData.pageNo"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="searchData.pageSize"
            layout="slot, total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-row>
      <!--上传对话框 action="/rest/CrmCustEmp/importBlackList"
                                    :before-upload="handlePreview"
                                    :on-success='handleSuccess'
                                    :on-error='handleError'
                                    :show-file-list="false"
            -->
      <el-dialog
        class="dialog"
        title="批量新增映射"
        :visible.sync="uploadDialog"
        width="500px"
        center
      >
        <div class="dialog-body">
          <div style="display: flex">
            <a
              style="color: blue; font-size: 18px; width: 41%;cursor:pointer"
              @click="downloadTmp()"
              >下载模板</a
            >
            <div>
              <el-upload
                class="upload-demo"
                ref="upload"
                :action="action"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-success="handleSuccess"
                :on-error="handleError"
                :auto-upload="false"
                :limit="1"
                :data="{ operatorId: openid }"
                :on-exceed="exceed"
                :on-change="changeUpload"
              >
                <!-- <el-a  slot="trigger"  style="color: blue; margin-left: 130px;">上传附件</el-a>  -->
                <a slot="trigger" @click="$refs.upload.clearFiles()" style="color: blue; font-size: 18px" 
                  >上传附件</a
                >
              </el-upload>
              <div slot="tip" class="el-upload__tip" v-if="fileList.length == 0">
                只能上传excel文件
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button class="dialog-btn" size="small" @click="bbb()">确认上传</el-button> -->
          <el-button
            class="dialog-btn"
            size="small"
            type="success"
            @click="submitUpload"
            :disabled="fileList.length === 0 || (fileList[0].percentage == 100)"
            :loading="uploading"
            >确认上传</el-button
          >
        </span>
      </el-dialog>
  
      <!--新增对话框-->
      <el-dialog
        class="dialog"
        title="新增映射"
        :visible.sync="uploadDialogi"
        width="600px"
        center
      >
        <div class="dialog-body" style="padding-right: 20px">
          <!-- <div style="display: flex; align-items: center">
            <span style="width: 80px">身份证号:</span
            ><el-input
              v-model="formData.idCard"
              placeholder="请输入身份证号..."
              :maxlength="18"
            ></el-input>
          </div> -->
          <div style="display: flex; align-items: center;">
            <span style="width: 80px; flex-shrink: 0; text-align: right">姓名：</span
            ><el-input
              v-model="formData.custEmpName"
              placeholder="请输入姓名..."
              :maxlength="20"
            ></el-input>
          </div>
          <div style="display: flex; align-items: center; margin-top: 10px">
            <span style="width: 80px; flex-shrink: 0; text-align: right">人员ID：</span
            ><el-input
              v-model="formData.empPkOrCode"
              placeholder="请输入人员ID..."
              :maxlength="18"
            ></el-input>
          </div>
          <div style="display: flex; align-items: center; margin-top: 10px">
            <span style="width: 80px; flex-shrink: 0; text-align: right">NC编码：</span
            ><el-input
              v-model="formData.custEmpCode"
              placeholder="请输入..."
              :maxlength="200"
            ></el-input>
          </div>
          <div style="display: flex; align-items: center; margin-top: 10px">
            <span style="width: 80px; flex-shrink: 0; text-align: right">职位：</span
            >
            <el-select
              clearable
              v-model="formData.custRole"
              filterable
              placeholder="请选择..."
            >
              <el-option
                :label="item"
                :value="item"
                v-for="(item, index) in allNcs"
                :key="index"
              ></el-option>
            </el-select>
          </div>

          <div style="padding-left: 80px; color: #f56c6c; margin-top: 10px">
            <p>注：如果职位是NC和兼职NC，人员ID需输入促销员ID；</p>
            <p style="text-indent: 2em">如果职位是NCL、NCM、NCTM，人员ID需输入督导人员编码</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="dialog-btn" size="small" @click="aaa()"
            >确定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        class="dialog"
        title="修改映射"
        :visible.sync="updateDialogi"
        width="600px"
        center
      >
        <div class="dialog-body">
          <div style="display: flex; align-items: center">
            <span style="width: 80px; flex-shrink: 0; text-align: right">身份证号：</span
            >
            <span>{{updateData.idCard}}</span>
          </div>
          <div style="display: flex; align-items: center; margin-top: 10px">
            <span style="width: 80px; flex-shrink: 0; text-align: right">姓名：</span
            >
            <span>{{updateData.custEmpName}}</span>
          </div>
          <div style="display: flex; align-items: center; margin-top: 10px">
            <span style="width: 80px; flex-shrink: 0; text-align: right">NC编码：</span
            ><el-input
              v-model="updateData.custEmpCode"
              placeholder="请输入..."
              :maxlength="200"
            ></el-input>
          </div>
          <div style="display: flex; align-items: center; margin-top: 10px">
            <span style="width: 80px; flex-shrink: 0; text-align: right">职位：</span
            >
            <el-select
              clearable
              v-model="updateData.custRole"
              filterable
              placeholder="请选择..."
            >
              <el-option
                :label="item"
                :value="item"
                v-for="(item, index) in allNcs"
                :key="index"
              ></el-option>
            </el-select>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="dialog-btn" size="small" @click="update()"
            >确定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import utils from "@/common/js/util.js";
  import moment from "moment";
  
  export default {
    data() {
      return {
        closeLoading: false,
        action: `/rest/CrmCustEmp/importEmployeeList`,
        openid: sessionStorage.getItem("sysUserId"),
        // pageNo: 1,
        // pageSize: 10,
        total: null,
        searchData: {
          custEmpName: null,
          idCard: null,
          empPk: null,
          custRole:null,
          pageNo: 1,
          custEmpCode: null,
          type:null,
          pageSize: 10,
          status: null
        },
        formData: {
          custEmpName: null,
          idCard: null,
          empPk: null,
          custRole:null,
          pageNo: 1,
          custEmpCode: null,
          type:null,
          pageSize: 10,
        },
        updateData:{
          id:null,
          custEmpName: null,
          idCard: null,
          empPk: null,
          custRole:null,
          pageNo: 1,
          custEmpCode: null,
          type:null,
          pageSize: 10,
        },
        tableData: [],
        listLoading: false,
        uploadDialog: false,
        uploadDialogi: false,
        updateDialogi:false,
        uploading: false,
        fileList: [],
        allNcs:[],
        rules: {
          idCard: [
            {
              pattern:
                /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
              message: "请输入15位或18位身份证号",
              trigger: "blur",
            },
          ],
        },
      };
    },
    mounted() {
      this.getData();
      this.getTerminal();
      this.$refs["formData"].resetFields();
    },
    methods: {
      formatIdCard(row, column, cellValue) {
        if (
          sessionStorage.getItem("user") == "admin1" ||
          sessionStorage.getItem("user") == "tinashi"
        ) {
          return cellValue;
        } else {
          return utils.plusXing(cellValue, 6, 4);
        }
      },
          //获取项目列表
    getTerminal() {
      this.$http({
        method: "GET",
        url: "/rest/CrmCustEmp/ncList",
      })
        .then((res) => {
          this.allNcs = res.data;
        })
        .catch((err) => {
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
      formatName(row, column, cellValue) {
        let a = cellValue[0];
        if (
          sessionStorage.getItem("user") == "admin1" ||
          sessionStorage.getItem("user") == "tinashi"
        ) {
          return cellValue;
        } else {
          for (let i = 0; i < cellValue.length - 1; i++) {
            a = a + "*";
          }
          return a;
        }
      },
      insertBatchs() {
        this.uploadDialog = true;
        this.$nextTick(()=>{
            this.$refs.upload.clearFiles()
        })
      },
      getData(pageNo) {
        console.log("pageNopageNopageNopageNopageNopageNo:" + this.searchData.pageNo)
        if (pageNo) {
          this.searchData.pageNo = pageNo;
        }
        this.listLoading = true;
        this.$http({
          method: "POST",
          url: "/rest/CrmCustEmp/findCBByIdCardAndName",
          params: this.searchData,
        })
          .then((res) => {
            console.log(res.data);
            this.tableData = res.data.data.list;
            this.listLoading = false;
            this.total = res.data.data.totalCount;
          })
          .catch((err) => {
            if (err.response) {
              let errMsg;
              if (err.response.message) {
                errMsg = err.response.message;
              } else {
                errMsg = "查询失败，请稍后重试";
              }
              this.$notify({
                title: "失败",
                message: errMsg,
                type: "error",
              });
            }
            this.listLoading = false;
          });
  
      },
      handleSizeChange(val) {
        this.searchData.pageSize = val;
        this.getData();
      },
      handleCurrentChange(val) {
        this.searchData.pageNo = val;
        this.getData();
      },
      formatDate(row, column, cellValue) {
        if (cellValue) {
          return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
        } else {
          return "";
        }
      },
      remove(id) {
        this.$http({
          method: "POST",
          url: "/rest/CrmCustEmp/removeCrmCustEmp",
          params: {
            id: id,
          },
        })
          .then((res) => {
            this.getData();
            this.$notify({
              title: "成功",
              message: "移除黑名单成功",
              type: "success",
            });
          })
          .catch((err) => {
            let errMsg;
            if (err.response.message) {
              errMsg = err.response.message;
            } else {
              errMsg = "操作失败，请稍后重试";
            }
            this.$notify({
              title: "失败",
              message: errMsg,
              type: "error",
            });
          });
      },
      downloadTmp() {
        this.$http({
          method: "POST",
          url: "/rest/CrmCustEmp/exportTemplate",
        })
          .then((res) => {
            if (
              res &&
              res.data &&
              (res.data.code == 0 || res.data.code == null)
            ) {
              location.href = utils.returnUrlHead() + res.data.data;
            }
          })
          .catch((err) => {
            utils.myNotify(this, "error", err.response, "查询失败，请稍后重试");
          });
      },
      changeUpload(file, fileList) {
            this.fileList = fileList
        },
      handleSuccess(response, file, fileList) {
        console.log("222", response);
        this.uploading = false
        if (response.code == 0) {
          utils.myNotify(this, "success", response.msg);
          this.getData();
          this.uploadDialog = false;
          this.fileList = [];
        }else {
          // utils.myNotify(this, "error", response.msg);
            if (response.url) {
            this.$confirm("上传失败，点击确认下载错误文件！", "提示", {
              type: "warning",
              callback(action) {
                // console.log("action: ", action);
                if (action === "confirm") {
                  window.open(location.origin + '/' + response.url);
                }
              }
            });
          } else {
            utils.myNotify(this, "error", response.msg);
          }
        }
      },
      handleError(err, response, file) {
        this.uploading = false
        let msg = "文件上传失败";
        if (!response || !response.message) {
          msg = "请求超时，请稍后再试";
        } else {
          msg = response.message;
          msg = msg.split("。").join("\n");
        }
        this.$alert(msg, "提示", {
          dangerouslyUseHTMLString: true,
          // callback: (action) => {
          //   this.uploadDialog = false;
          // },
        });
      },
      exportData() {
        this.listLoading = true;
        this.$http({
          method: "POST",
          url: "/rest/CrmCustEmp/exportEmployeeList",
          params: this.searchData,
        })
          .then((res) => {
            console.log(utils.returnUrlHead() +res.data.data);
            location.href = utils.returnUrlHead() + res.data.data;
            console.log(res.data.data);
            this.listLoading = false;
          })
          .catch((err) => {
            if (err.response) {
              let errMsg;
              if (err.response.message) {
                errMsg = err.response.message;
              } else {
                errMsg = "导出失败，请稍后重试";
              }
              this.$notify({
                title: "失败",
                message: errMsg,
                type: "error",
              });
            }
            this.listLoading = false;
          });
      },
      //点击确定
      aaa() {
        const reg = /^[A-Za-z0-9]+$/;
        let msg = ''
        if (!this.formData.custEmpName) {
          msg = '请输入姓名'
        } else if (!reg.test(this.formData.empPkOrCode || '')) {
          msg = '人员ID信息错误，请修改后重新上传！'
        } else if (!this.formData.custEmpCode) {
          msg = '请输入NC编码'
        } else if (!this.formData.custRole) {
          msg = '请选择职位'
        }
        if (msg) {
          utils.myNotify(this, "error", msg);
          return;
        }
        // this.formatDate.cardId,
        this.listLoading = true;
        this.$http({
          method: "POST",
          url: "/rest/CrmCustEmp/save",
          params: {
            empPkOrCode: this.formData.empPkOrCode,
            custEmpCode: this.formData.custEmpCode,
            custEmpName: this.formData.custEmpName,
            custRole: this.formData.custRole,
            type :0, 
            status: 0,
          },
        })
          .then((res) => {
            console.log("3333333333", res);
            this.listLoading = false;
            // if(res.data.code===500){
            //       utils.myNotify(this, "error", res.data.msg);
            // }else {
            //     utils.myNotify(this, "success", res.data.msg);
            // }
            console.log("44444", res.data.code != 0);
            if (
              res &&
              res.data &&
              (res.data.code == 0)
            ) {
              utils.myNotify(this, "success", "新增成功");
              this.uploadDialogi = false;
              this.getData();
            }
            if (
              res &&
              res.data &&
              (res.data.code != 0 || res.data.code == null)
            ) {
              console.log("55555", res.data.message);
              utils.myNotify(this, "error", res.data.msg);
              // this.uploadDialogi = false;
              // this.getData();
            }
          })
          .catch((err) => {
            utils.myNotify(this, "error", err.response, "新增失败，请稍后重试");
          });
      },
      // 关闭人员映射
      closeEmployee(row) {
        // await this.$confirm("关闭后该人员没有映射关系，确认关闭吗?", "提示", {
        // confirmButtonText: "确定",
        // cancelButtonText: "取消",
        // type: "warning",
      // });
        this.closeLoading = true
        this.$http({
          method: "POST",
          url: "/rest/CrmCustEmp/save",
          params: {
            id: row.id,
            idCard: row.idCard,
            custEmpCode: row.custEmpCode,
            custEmpName: row.custEmpName,
            custRole: row.custRole,
            type :1,
            status: 1,
          },
        })
          .then((res) => {
            this.closeLoading = false
            console.log("res.data.code:" + res.data.code)
            if ( res && res.data && (res.data.code == 0) ) {
              utils.myNotify(this, "success", "修改成功");
              this.updateDialogi = false;
              this.getData();
            }
            if ( res && res.data && (res.data.code != 0 || res.data.code == null) ) {
              utils.myNotify(this, "error", res.data.msg);
            }
          })
          .catch((err) => {
            this.closeLoading = false
            utils.myNotify(this, "error", err.response, "关闭失败，请稍后重试");
          });
      },
      update(){
        this.$http({
          method: "POST",
          url: "/rest/CrmCustEmp/save",
          params: {
            id: this.updateData.id,
            idCard: this.updateData.idCard,
            custEmpCode: this.updateData.custEmpCode,
            custEmpName: this.updateData.custEmpName,
            custRole: this.updateData.custRole,
            type :1,
          },
        })
          .then((res) => {
            console.log("res.data.code:" + res.data.code)
            if (
              res &&
              res.data &&
              (res.data.code == 0)
            ) {
              utils.myNotify(this, "success", "修改成功");
              this.updateDialogi = false;
              this.getData();
            }
            if (
              res &&
              res.data &&
              (res.data.code != 0 || res.data.code == null)
            ) {
              utils.myNotify(this, "error", res.data.msg);
              // this.getData();
            }
          })
          .catch((err) => {
            utils.myNotify(this, "error", err.response, "修改失败，请稍后重试");
          });
      },
      // action="/rest/CrmCustEmp/importBlackList"
      //                               :before-upload="handlePreview"
      //                               :on-success='handleSuccess'
      //                               :on-error='handleError'
      //                               :show-file-list="false"
      submitUpload() {
        // operatorId: sessionStorage.getItem('sysUserId')
        console.log(this.openid);
        this.uploading = true
        this.$refs.upload.submit();
      },
      handleRemove(file, fileList) {
        console.log(2);
        this.fileList = [];
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(3);
  
        console.log(file);
      },
      exceed(files, fileList) {
        // this.$refs.upload.clearFiles();
        utils.myNotify(this, "warning", "只能上传一个文件,请删除后重新上传！");
      },
      handleUpload() {
        console.log(111);
        this.$refs.upload.clearFiles();
      },
      updateEmployee(employee){
        this.updateData.id = employee.id;
        this.updateData.custEmpCode = employee.custEmpCode;
        this.updateData.custEmpName = employee.custEmpName;
        this.updateData.idCard = employee.custEmpIdcard;
        this.updateData.custRole = employee.custRole;
        this.updateDialogi = true;
      },
      add(){
        this.formData = {
          custEmpName: null,
          idCard: null,
          empPk: null,
          custRole:null,
          pageNo: 1,
          custEmpCode: null,
          type:null,
          pageSize: 10,
        };
        this.uploadDialogi = true;
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .search-btn {
    margin-left: 75px;
  }
  .el-button.is-disabled,.el-button.is-disabled:hover,.el-button.is-disabled:focus {
      background-color: white !important;
      opacity: 0.5;
      border: none;
  }
  </style>
  
  


// WEBPACK FOOTER //
// src/views/configCanage/mappingMead/MappingMead.vue